import React, { createContext, useContext, useState, useEffect } from 'react';
import { kullanicilarAPI, yetkilerAPI } from '../services/api';

const AuthContext = createContext(null);

const DEFAULT_ROLE_PERMISSIONS = {
  admin: [
    '/', '/malzemeler', '/urunler', '/uretimler', '/paketleme',
    '/satislar', '/alislar', '/odemeler', '/tahsilatlar', '/virman', '/cariler', '/musteriler', '/kasalar',
    '/ajanda', '/kullanicilar', '/satis-takvimi', '/raporlama', '/log-kayitlari',
    '/ayarlar/liste-fiyatlari', '/ayarlar/gelir-tipleri'
  ],
  yonetici: [
    '/', '/malzemeler', '/urunler', '/uretimler', '/paketleme',
    '/satislar', '/alislar', '/odemeler', '/tahsilatlar', '/virman', '/cariler', '/musteriler', '/kasalar',
    '/ajanda', '/satis-takvimi', '/raporlama'
  ],
  personel: [
    '/', '/malzemeler', '/urunler', '/uretimler', '/paketleme',
    '/ajanda'
  ]
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rolePermissions, setRolePermissions] = useState(DEFAULT_ROLE_PERMISSIONS);

  const fetchPermissions = async () => {
    try {
      const res = await yetkilerAPI.getAll();
      const perms = {};
      if (Array.isArray(res.data)) {
        res.data.forEach(item => {
          perms[item.rol.toLowerCase()] = item.izinler || [];
        });
      }
      if (Object.keys(perms).length > 0) {
        setRolePermissions(prev => ({ ...prev, ...perms }));
      }
    } catch {
      // API yoksa veya hata varsa default izinleri kullan
    }
  };

  useEffect(() => {
    const saved = localStorage.getItem('evdeye_user');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.mesaj || !parsed.id) {
          localStorage.removeItem('evdeye_user');
        } else {
          if (!parsed.rol) parsed.rol = 'admin';
          setUser(parsed);
        }
      } catch {
        localStorage.removeItem('evdeye_user');
      }
    }
    setLoading(false);
    fetchPermissions();
  }, []);

  const login = async (email, sifre) => {
    const res = await kullanicilarAPI.login({ email, sifre });
    const userData = res.data.kullanici || res.data;
    const token = res.data.token;
    if (!userData.rol) {
      userData.rol = 'admin';
    }
    if (token) {
      localStorage.setItem('evdeye_token', token);
    }
    setUser(userData);
    localStorage.setItem('evdeye_user', JSON.stringify(userData));
    return userData;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('evdeye_user');
    localStorage.removeItem('evdeye_token');
  };

  const refreshPermissions = () => fetchPermissions();

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, rolePermissions, refreshPermissions }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export const ROLE_PERMISSIONS = DEFAULT_ROLE_PERMISSIONS;

export function hasPermission(user, path, rolePermissions) {
  if (!user || !user.rol) return false;
  const perms = rolePermissions || DEFAULT_ROLE_PERMISSIONS;
  const allowed = perms[user.rol.toLowerCase()];
  return allowed ? allowed.includes(path) : false;
}
